import React from 'react';

const NotSortableHeaderCell = ({ title, children }) => (
  <span className='k-cell-inner !k-cursor-default'>
    <span className='k-link !k-cursor-default'>
      <span className='k-column-title' title='Not sortable'>{title}</span>
      {children}
    </span>
  </span>
);

export default NotSortableHeaderCell;
